import { render, staticRenderFns } from "./BillOfMaterial.vue?vue&type=template&id=093586c4&scoped=true&"
import script from "./BillOfMaterial.vue?vue&type=script&lang=js&"
export * from "./BillOfMaterial.vue?vue&type=script&lang=js&"
import style0 from "./BillOfMaterial.vue?vue&type=style&index=0&id=093586c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093586c4",
  null
  
)

export default component.exports